import React, { useState, useEffect, useContext } from "react";
import { Button, InputGroup, Form, Row, Col, ButtonGroup } from 'react-bootstrap';
import { UserInformationContext, AdminUserInformationContext, SitterUserInformationContext, C4FStatusContext } from "../main/App";
import { isEmptyString } from "./Helpers";

function C4FChat(props) {

    const [chat, setChat] = useState('');
    const [chatMessage, setChatMessage] = useState('');
    const { userInformation } = useContext(UserInformationContext);
    const { adminUserInformation } = useContext(AdminUserInformationContext);
    const { sitterUserInformation } = useContext(SitterUserInformationContext);
    const { handleBackendRequest } = useContext(C4FStatusContext);
    const [responseStatus, setResponseStatus] = useState('ok');

    const roleName = (role) => {
        if (!role || isEmptyString(role)) return '';
        if (role === 'FairplayCommittee') return 'FPC';
        if (role === 'Admin') return 'Admin';
        if (role === 'Mentor') return 'Mentor';
        return '';
    }

    function sendMessage() {
        let messageToSend = chatMessage;
        messageToSend = messageToSend.trim();
        if (messageToSend.length === 0)
            setChatMessage('');
        else {
            setResponseStatus('pending');
            handleBackendRequest('POST', '/chat', { message: messageToSend }, 
                {
                    type: props.type,
                    chat: props.chat,
                    user: userInformation.userName + (isEmptyString(roleName(props.role)) ? '' : ' / ' + roleName(props.role)),
                    adminUser: adminUserInformation !== null ? adminUserInformation.userName : (sitterUserInformation !== null ? sitterUserInformation.userName : null)
                },
                function (saveChatResponse) {
                    setResponseStatus('ok');
                    setChatMessage('');
                    setChat(saveChatResponse.chat);
                    if ('setOnline' in props) props.setOnline();
                }, 
                true, 
                setResponseStatus('failed'), 
                true);
        }
    }

    function getChat(updateOnlineStatus) {
        setResponseStatus('pending');
        handleBackendRequest('GET', '/chat', null, 
            { type: props.type, chat: props.chat },
            function (getChatResponse) {
                setResponseStatus('ok');
                setChat(getChatResponse.chat);
                if (updateOnlineStatus && 'setOnline' in props) props.setOnline();
            }, 
            true, 
            setResponseStatus('failed'), 
            true);
    }

    useEffect(() => {
        getChat(false);
    }, [props.type, props.chat, props.refresh]);

    return <>
        {(() => {
            if (props.mode !== 'readonly')
                return <Row style={{ height: "32px" }} className="my-1 mb-1 justify-content-center">
                    <Col className="mx-1 my-0 px-0 py-0">
                    <InputGroup>
                        <Form.Control className="w-50" style={{ fontSize: "0.875em" }}
                            onChange={(e) => setChatMessage(e.target.value)}
                            onKeyPress={(e) => (e.key === 'Enter') ? sendMessage() : null}
                            placeholder="chat message"
                            value={chatMessage} />
                        <ButtonGroup>
                            {responseStatus === 'pending' ?
                                <Button
                                    className="py-0"
                                    variant="success"
                                    size="sm"
                                    disabled
                                >{'\u2713'}</Button>
                                :
                                <Button
                                    className="py-0"
                                    variant="success"
                                    size="sm"
                                    onClick={(e) => sendMessage()}
                                >{'\u2713'}</Button>
                            }
                            <Button
                                className="py-0"
                                variant="danger"
                                size="sm"
                                onClick={(e) => setChatMessage('')}
                            >X</Button>
                            <Button
                                className="py-0"
                                variant="primary"
                                size="sm"
                                onClick={(e) => getChat(true)}
                            >{'\u21BB'}</Button>
                            <Button size="sm" disabled variant="secondary">
                                {responseStatus === 'ok' ? '\uD83D\uDFE2' : null}
                                {responseStatus === 'pending' ? '\uD83D\uDFE1' : null}
                                {responseStatus === 'failed' ? '\uD83D\uDD34' : null}
                            </Button>
                        </ButtonGroup>
                    </InputGroup>
                    </Col>
                </Row>
        })()}
        <Row style={{ height: (props.height - 40) + 'px', overflow: "auto" }}>
            <Col className="mx-1 my-0 px-0 py-0">
                <p className="text-justify mx-0 my-0 px-0 py-0" style={{ fontSize: "0.875em" }}>
                    {chat.split('\n').map((item) => {
                        let prepareSplitItem = item.replaceAll(props.user, '+*+' + props.user + '+*+');
                        let splitItem = prepareSplitItem.split('+*+');
                        return <>
                            {splitItem.map(function (part) {
                                if (part === props.user)
                                    return <mark><strong>{part}</strong></mark>
                                else
                                    return <>{part}</>
                            })}
                            <br />
                        </>
                    })
                    }
                </p>
            </Col>
        </Row>
    </>
}

export default C4FChat;